import {Rating} from "@api/models/Rating";

export interface RealtimeCallback {
    (arg: any): void;
}

export interface RealtimeMessageModel {
    data?: any;
    objectId?: string;
    schemaId?: string;
    error?: string;
    likes?: Rating;
    isFavorite?: boolean;

    /**
     * comments count
     */
    comments?: number;
}

export interface Observer {
    channels: string[];
    callback: RealtimeCallback;
}

export interface MethodObserver {
    channel: string;
    callback: RealtimeCallback;
}

export type ObserverMethods = Record<string, RealtimeCallback>;
export type Observers = Record<string, ObserverMethods>;


export enum SignalRMethod {
    objectUpdated = 'object.updated',
    objectLikesUpdated = "object.likesUpdated",
    commentsUpdated = "comments.updated",
    objectCommentsCountUpdated = "object.commentsCountUpdated",
    notificationsUpdated = "notifications.updated",
    meetingsUpdated = "meetings.updated",
    meetingsCommentsUpdated = "meetings.commentsUpdated",
    meetingsInvitesUpdated = "meetings.invitesUpdated",
    configurationUpdated = "configuration.updated",
    activityJoined = "activity.joined",
    activityLeft = "activity.left",
    newMessengerEvent = "NewMessengerEvent",
    webConferencePresentersUpdated = "webConference.presenters.updated",
    webConferenceUserHandsUpdate = "webConference.userHands.updated",
    webConferenceStreamsUpdated = "webConference.streams.updated",
    webConferenceRecordingUpdate = "webConference.recording.updated",
    webConferenceCurrenPresentationUpdated = "webConference.currentPresentation.updated",
    webConferenceSlidesUpdated = 'webConference.slides.updated',
    favoritesUpdated = 'favorites.updated'
}

export enum SignalRBackendMethod {
    Subscribe = 'Subscribe',
    Unsubscribe = 'Unsubscribe'
}
